import { ViewerModalFrame, ViewerModalSection, type ViewerModalTheme } from './ViewerModalFrame';

export interface Tool {
  name: string;
  image: string;
  description: string;
}

interface ToolsListModalProps {
  open: boolean;
  onClose: () => void;
  tools: Tool[];
  title?: string;
  theme?: ViewerModalTheme;
}

export function ToolsListModal({
  open,
  onClose,
  tools,
  title = 'Required Tools',
  theme,
}: ToolsListModalProps) {
  const t = {
    primaryTextColor: 'rgba(255, 255, 255, 0.95)',
    secondaryTextColor: 'rgba(255, 255, 255, 0.7)',
    borderColor: 'rgba(255, 255, 255, 0.1)',
    ...theme,
  };

  return (
    <ViewerModalFrame open={open} onClose={onClose} title={title} titleIcon="build" theme={theme}>
      <ViewerModalSection title={`${tools.length} tool${tools.length !== 1 ? 's' : ''} needed`} theme={theme}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
          {tools.map((tool, index) => (
            <div
              key={index}
              style={{
                border: `1px solid ${t.borderColor}`,
                borderRadius: '0.75rem',
                overflow: 'hidden',
                background: 'rgba(255, 255, 255, 0.02)',
              }}
            >
              <div
                style={{
                  height: '5rem',
                  backgroundColor: 'rgba(255, 255, 255, 0.04)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={tool.image}
                  alt={tool.name}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </div>
              <div style={{ padding: '0.75rem' }}>
                <div style={{ fontWeight: 500, color: t.primaryTextColor, fontSize: '0.8125rem', marginBottom: '0.25rem' }}>
                  {tool.name}
                </div>
                <div style={{ fontSize: '0.75rem', color: t.secondaryTextColor }}>
                  {tool.description}
                </div>
              </div>
            </div>
          ))}
          {tools.length === 0 && (
            <p style={{ fontSize: '0.8125rem', color: t.secondaryTextColor, padding: '1.5rem 0.5rem', textAlign: 'center' }}>
              No tools required.
            </p>
          )}
        </div>
      </ViewerModalSection>
    </ViewerModalFrame>
  );
}
